import type { FC } from 'react'

import { EndCall } from '@liveHelper/assets/EndCall'
import { Minimize } from '@liveHelper/assets/Minimize'
import { Dialing } from '@liveHelper/components/Dialing'
import {
  actionsSelector,
  useStore,
  visitorPrivateActionsSelector,
} from '@liveHelper/models/store'
import { ChatHeader } from '@oneToOne/shared/components/twind/ChatHeader'
import { ActionButton } from '@oneToOne/shared/styles'

import { useContextTranslation } from '@core/i18n'

import {
  ActionContainer,
  ChatHeaderDialingWrapper,
} from './ChatHeaderDialing.styles'

/**
 * Component for rendering the Chat Header in the Dialing state.
 */
export const ChatHeaderDialing: FC = () => {
  const { t } = useContextTranslation()
  const { terminateCall } = useStore(visitorPrivateActionsSelector)
  const { sendUIStateTransitionEvent } = useStore(actionsSelector)

  return (
    <ChatHeaderDialingWrapper>
      <ActionContainer>
        <ActionButton
          aria-label={t(`oneToOne:Minimize Widget`)}
          actionType="neutral"
          buttonSize="sm"
          shape="square"
          onClick={() => {
            sendUIStateTransitionEvent('MINIMIZE')
          }}
          icon={<Minimize width="16px" fill="white" label="minimize" />}
        />
      </ActionContainer>
      <Dialing />
      <ChatHeader
        title={t(`oneToOne:Chat`)}
        actions={
          <ActionButton
            aria-label={t(`oneToOne:Cancel Call`)}
            actionType="danger"
            shape="square"
            buttonSize="sm"
            onClick={() => terminateCall?.({ type: 'stopDialing' })}
            icon={<EndCall width="18px" fill="var(--white)" label="end call" />}
          />
        }
      />
    </ChatHeaderDialingWrapper>
  )
}
